import { create } from 'zustand';
import api from '../lib/api';
import type { OverviewSummary } from '../types/admin';

interface AdminOverviewState {
  summary: OverviewSummary | null;
  loading: boolean;
  error: string | null;
  fetch: () => Promise<void>;
  startPolling: () => void;
  stopPolling: () => void;
}

const POLL_INTERVAL_MS = 30_000;
let pollHandle: number | null = null;

export const useAdminOverviewStore = create<AdminOverviewState>((set, get) => ({
  summary: null,
  loading: false,
  error: null,
  async fetch() {
    set({ loading: true });
    try {
      const res = await api.get<OverviewSummary>('/api/admin/overview/summary');
      set({ summary: res.data, loading: false, error: null });
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to load overview';
      set({ loading: false, error: message });
    }
  },
  startPolling() {
    if (pollHandle !== null) return;
    pollHandle = window.setInterval(async () => {
      await get().fetch();
      if (get().summary && !get().summary!.syncs.anyInFlight) {
        get().stopPolling();
      }
    }, POLL_INTERVAL_MS);
  },
  stopPolling() {
    if (pollHandle !== null) {
      window.clearInterval(pollHandle);
      pollHandle = null;
    }
  },
}));
